import { createMutationHelper } from '@utils/swr'
import { type LoginByThirtyPartyRequest } from '../../../types/apiRequest'
import { type LoginByThirtyPartyResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<CosignApis['post']['loginByFacebook'], LoginByThirtyPartyResponse, LoginByThirtyPartyRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/facebook-login',
  fetcher: (url, { arg, client }) => {
    return client.post(url, arg)
  },
})

export const useRequestLoginByFacebook = useMutation
